import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminInvoiceContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeDownloaded!: boolean;

  @jsonMember(Boolean)
  public readonly canBeSynchronized!: boolean;

  @jsonMember(Boolean)
  public readonly canBeSendToKsef!: boolean;
}
